import "./BrandLogo.css";

/** Decorative inside an already named brand link; never changes navigation. */
export function BrandLogo({ compact = false, tone = "light" }: { compact?: boolean; tone?: "light" | "dark" }) {
  return <span className={`studio-logo${compact ? " studio-logo--compact" : ""}`} data-tone={tone} aria-hidden="true">
    <img className="studio-logo__mark" src={`${import.meta.env.BASE_URL}brand/stencil-studio-mark.webp`} alt="" width="128" height="128" />
    {!compact && <img className="studio-logo__wordmark" src={`${import.meta.env.BASE_URL}brand/stencil-studio-wordmark.webp`} alt="" width="640" />}
  </span>;
}
